<script lang="typescript">
    import { scrollToTop } from "svelte-scrollto"
    import {
        createPlanEntry,
        createTodo,
        deletePlanEntry,
        deleteTodo,
        getPlan,
        getProject,
        getTodo,
        getUser,
        getUsers,
        updatePlanEntry,
        updateTodo,
    } from "../api"
    import Fa from "svelte-fa/src/fa.svelte"
    import {
        faHistory,
        faCheck,
        faSignOutAlt,
        faPaintBrush,
        faFilter,
    } from "@fortawesome/free-solid-svg-icons"
    import { location } from "../store"
    import { tick } from "svelte"
    import { debounce } from "lodash"
    import UserList from "./UserList.svelte"
    import Filter from "./Filter.svelte"
    import PlanList from "./PlanList.svelte"
    import Overlay from "./Overlay.svelte"
    import EntryDialog from "./EntryDialog.svelte"
    import ProjectChart from "./ProjectChart.svelte"

    import { Datepicker } from "svelte-calendar"
    import { calenderTheme } from "../config"
    import { fade } from "svelte/transition"
    import { log } from "../../api/hooks/lib/utils"
    import Symbol from "./Symbol.svelte"

    export let url = ""
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            categoryPath: l[0].replace(/\/\d{4,99}[^\/]+$/, ""),
            push: false,
            pop: false,
        }
    }

    let darkmode = false
    let showfilter = false

    // scroll to top on new site
    location.subscribe((l) => {
        if (l.push) scrollToTop()
    })

    if (typeof window !== "undefined") console.log("App initialized")

    let activeUser

    let series: {
        [key: string]: PlanEntry
    } = {}

    let hasMore = false
    let loading = false
    let loading2 = false
    let page = 1

    let startDate = new Date()
    startDate.setDate(startDate.getDate() - 90)
    let endDate = new Date()
    endDate = new Date(
        endDate.getFullYear() + 1,
        endDate.getMonth(),
        endDate.getDate()
    )

    let plan: PlanEntry[] = []
    let todo: PlanEntry[] = []
    let oldUser: User
    let oldStartDate: Date
    let oldEndDate: Date

    let abortController: AbortController
    let abortController2: AbortController
    const newLoadPlan = debounce(function () {
        if (abortController) {
            abortController.abort() // cancel all running requests
        }
        tick().then(() => {
            loadPlan(300)
        })
    }, 200)

    const newLoadTodo = debounce(function () {
        if (abortController2) {
            abortController2.abort() // cancel all running requests
        }
        tick().then(() => {
            loadTodo(300)
        })
    }, 200)

    $: if (
        activeUser &&
        (oldUser?.id != activeUser?.id ||
            startDate != oldStartDate ||
            endDate != oldEndDate)
    ) {
        if (oldUser?.id != activeUser?.id) {
            todo = []
            loading2 = true
            newLoadTodo()
        }

        oldUser = activeUser
        oldStartDate = startDate
        oldEndDate = endDate
        loading = true
        plan = []
        hasMore = false
        series = {}
        page = 1
        newLoadPlan()
    }

    async function loadPlan(delay = 0) {
        abortController = new AbortController()
        const { signal } = abortController
        try {
            const startTime = Date.now()
            const _plan = await getPlan(
                activeUser,
                page,
                startDate,
                endDate,
                signal
            )
            const duration = Date.now() - startTime
            delay -= duration

            if (delay > 0) {
                await new Promise((resolve) => setTimeout(resolve, delay))
            }
            _plan.forEach((p) => {
                if (p.series_id) {
                    const s = series[p.series_id]
                    if (s) {
                        s.ends_on = p.ends_on
                        s.color = p.color || s.color
                    } else {
                        series[p.series_id] = p
                        plan.push(p)
                    }
                } else {
                    plan.push(p)
                }
            })
            hasMore = _plan.length >= 100
            plan = plan
        } catch (e) {
            console.log(e)
        }
        loading = false
    }

    async function loadTodo(delay = 0) {
        abortController2 = new AbortController()
        const { signal } = abortController2
        try {
            const startTime = Date.now()
            const _todo = await getTodo(activeUser, signal)
            const duration = Date.now() - startTime
            delay -= duration

            if (delay > 0) {
                await new Promise((resolve) => setTimeout(resolve, delay))
            }
            todo = _todo
        } catch (e) {
            console.log(e)
        }
        loading2 = false
    }

    let symbolFilter = {
        0: true,
        1: true,
        2: true,
        3: true,
        4: true,
        5: true,
        6: true,
        7: true,
        8: true,
        9: true,
        10: true,
        11: true,
        12: false,
        13: true,
    }

    let createOverlayOpen = false

    let showGraph = false

    async function onPlanEntryUpdate(e, isTodo: boolean) {
        let _p: PlanEntry
        const data: PlanEntry = e.detail
        const id = data.id
        delete data.id

        const add2Moco = async () => {
            try {
                _p = await createPlanEntry(data)
                plan.push(_p)
                plan = plan
            } catch (e) {
                console.log(e)
                alert("FEHLER: siehe Konsole")
            }
        }

        const add2WmBasic = async () => {
            try {
                _p = await createTodo(data)
                _p.user = await getUser(_p.user_id)
                _p.project = await getProject(_p.project_id)
                todo.push(_p)
                todo = todo
            } catch (e) {
                console.log(e)
                alert("FEHLER, siehe Konsole")
            }
        }

        if (isTodo) {
            if (id) {
                if (!data.starts_on) {
                    // update
                    console.log("update wmbasic")
                    try {
                        _p = await updateTodo(id as string, data)
                        _p.user = await getUser(_p.user_id)
                        _p.project = await getProject(_p.project_id)
                        for (let i = 0; i < todo.length; i++) {
                            if (todo[i].id == _p.id) {
                                todo[i] = _p
                            }
                        }
                        todo = todo
                    } catch (e) {
                        console.log(e)
                        alert("FEHLER, siehe Konsole")
                    }
                } else {
                    // move
                    console.log("move wmbasic to moco")
                    await add2Moco()
                    try {
                        await deleteTodo(id as string)
                        todo = todo.filter((t) => t.id != id)
                    } catch (e) {
                        console.log(e)
                        alert("FEHLER, siehe Konsole")
                    }
                }
            } else {
                // add
                console.log("add to wmbasic")
                await add2WmBasic()
            }
        } else {
            if (id) {
                if (data.starts_on) {
                    // update
                    console.log("update moco")
                    try {
                        _p = await updatePlanEntry(id as number, data)
                        for (let i = 0; i < plan.length; i++) {
                            if (plan[i].id == _p.id) {
                                plan[i] = _p
                            }
                        }
                        plan = plan
                    } catch (e) {
                        console.log(e)
                        alert("FEHLER: siehe Konsole")
                    }
                } else {
                    // move
                    console.log("move moco to wmbasic")
                    await add2WmBasic()
                    try {
                        await deletePlanEntry(id as number)
                        plan = plan.filter((p) => p.id != id)
                    } catch (e) {
                        console.log(e)
                        alert("FEHLER: siehe Konsole")
                    }
                }
            } else {
                // add
                console.log("add to moco")
                await add2Moco()
            }
        }
    }
</script>

<style lang="less" global>
    @import "./../css/themes/default/theme.less";
</style>

<div class:darkmode class="container">
    <div class="topbar">
        <div class="left">
            <div class="logo layout layout-gap">
                <span class="hidden-sm">WM</span>
                <span>TODO</span>
            </div>
            <div class="tabnav">
                <button
                    class:active="{!showGraph}"
                    on:click="{() => {
                        showGraph = false
                    }}"
                    ><Fa icon="{faCheck}" size="1.2em" />
                    <span class="hidden-sm">Aufgabenliste</span>
                </button
                >
                <button
                    class:active="{showGraph}"
                    on:click="{() => {
                        showGraph = true
                    }}"
                    ><Fa icon="{faHistory}" size="1.2em" />
                    <span class="hidden-sm">Zeitstrahl</span>
                </button
                >
            </div>
        </div>
        <div class="right">
            {#if activeUser}
                <div class="filter_container">
                    <div
                        class="filter_trigger"
                        on:click|stopPropagation="{() => {
                            showfilter = !showfilter
                        }}"
                        class:active="{showfilter}"
                    >
                        <Fa icon="{faFilter}" size="1.2em" />
                        <span class="text hidden-sm">Filter</span>
                    </div>
                    <Filter bind:showfilter bind:symbolFilter />
                </div>
            {/if}
            <div class="datepickers">
                <Datepicker
                    bind:selected="{startDate}"
                    format="DD.MM.YYYY"
                    theme="{calenderTheme}"
                    startOfWeekIndex="{1}"
                />
                <span class="hidden-sm">bis</span>
                <Datepicker
                    bind:selected="{endDate}"
                    format="DD.MM.YYYY"
                    theme="{calenderTheme}"
                    startOfWeekIndex="{1}"
                />
            </div>
            <div title="darkmode" class="mode" class:active="{darkmode}"
                on:click="{() => {
                    darkmode = !darkmode
                }}"
            >
                <Fa icon="{faPaintBrush}" size="1.2em" />
            </div>
            <div
                class="logout"
                on:click="{() => {
                    window.localStorage.removeItem('mocoApiKey')
                    window.localStorage.removeItem('wmbasicApiKey')
                    document.location.reload()
                }}"
            >
                <Fa icon="{faSignOutAlt}" size="1.2em" />
            </div>
        </div>
    </div>
    <div class="leftbar">
        <div class="section">
            <div class="title hidden-sm">Team</div>
            <UserList bind:activeUser />
        </div>
        <!--
        <div class="section">
            <div class="title">Projekte</div>
            <div class="projects">
                <div class="item">
                    <div class="point" style="background:blue;"></div>
                    <div class="ptitle">
                        Sachsen AM<span class="nr">(5)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="point" style="background:var(--colors-red-500);"></div>
                    <div class="ptitle">
                        Webmakers<span class="nr">(4)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="point" style="background:green;"></div>
                    <div class="ptitle">
                        Stiftung Familienunternehmen<span class="nr">(2)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="point" style="background:yellow;"></div>
                    <div class="ptitle">
                        Gelbes Projekt<span class="nr">(9)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="point" style="background:blue;"></div>
                    <div class="ptitle">
                        Blaues Projekt<span class="nr">(18)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="point" style="background:white;"></div>
                    <div class="ptitle">
                        Noch ein Projekt<span class="nr">(6)</span>
                    </div>
                </div>
            </div>
        </div>
        -->
    </div>
    <div class="maincontent">
        <div class="maincontent_inner layout layout-col-2 layout-gap">
            
            <div class="planlists">
                {#if showGraph}
                    {#if plan?.length}
                        {#await getUsers() then users}
                            <div in:fade="{{ delay: 300 }}">
                                <ProjectChart
                                    items="{plan?.filter((e) => {
                                        if (
                                            symbolFilter[
                                                e.symbol ? e.symbol : 0
                                            ] &&
                                            (!activeUser?.id ||
                                                activeUser.id == e.user?.id)
                                        ) {
                                            return true
                                        }
                                        return false
                                    })}"
                                    users="{users}"
                                />
                            </div>
                        {/await}
                    {/if}
                {:else}
                    <div class="planlist">
                        <PlanList
                            items="{plan
                                ?.filter((e) => {
                                    if (
                                        symbolFilter[e.symbol ? e.symbol : 0] &&
                                        (!activeUser?.id ||
                                            activeUser.id == e.user?.id)
                                    ) {
                                        return true
                                    }
                                    return false
                                })
                                .sort((a, b) => {
                                    const aStart = new Date(a.starts_on)
                                    const bStart = new Date(b.starts_on)
                                    if (aStart.getTime() != bStart.getTime()) {
                                        return aStart < bStart ? -1 : 1
                                    }
                                    const aEnd = new Date(a.ends_on)
                                    const bEnd = new Date(b.ends_on)
                                    if (aEnd.getTime() != bEnd.getTime()) {
                                        return aEnd < bEnd ? -1 : 1
                                    }
                                    if (a.symbol != b.symbol) {
                                        return a.symbol == 13 ? -1 : 1
                                    }
                                    return a.title < b.title ? -1 : 1
                                })}"
                            on:symbolUpdate="{(e) => {
                                ;(async function () {
                                    await updatePlanEntry(e.detail.id, {
                                        symbol: e.detail.symbol,
                                        title: e.detail.title, // TODO moco bug
                                    })
                                    plan = plan
                                })()
                            }}"
                            on:userUpdate="{(e) => {
                                ;(async function () {
                                    const _p = await updatePlanEntry(
                                        e.detail.id,
                                        {
                                            user_id: e.detail.user_id,
                                            title: e.detail.title, // TODO moco bug
                                        }
                                    )
                                    e.detail.user = _p.user
                                    plan = plan
                                })()
                            }}"
                            on:update="{(e) => {
                                onPlanEntryUpdate(e, false)
                            }}"
                            on:delete="{(e) => {
                                deletePlanEntry(e.detail.id)
                                    .then(() => {
                                        plan = plan.filter(
                                            (p) => p.id != e.detail.id
                                        )
                                    })
                                    .catch((e) => {
                                        console.log(e)
                                        alert('FEHLER: siehe Konsole')
                                    })
                            }}"
                        />
                        {#if hasMore}
                            <div style="text-align: center; padding: 20px;">
                                <button
                                    style="width: 200px; height: var(--space-xl);"
                                    on:click="{() => {
                                        page++
                                        loading = true
                                        loadPlan()
                                    }}">mehr laden</button
                                >
                            </div>
                        {/if}
                    </div>
                {/if}
            </div>
            <div>
                {#if todo?.length}
                    <div class="planlist">
                        <PlanList
                            items="{todo
                                ?.filter((e) => {
                                    if (
                                        symbolFilter[e.symbol ? e.symbol : 0] &&
                                        (!activeUser?.id ||
                                            activeUser.id == e.user?.id)
                                    ) {
                                        return true
                                    }
                                    return false
                                })
                                .sort((a, b) => {
                                    if (a.sort && b.sort && a.sort != b.sort)
                                        return a.sort < b.sort ? -1 : 1
                                    if (a.sort && !b.sort) return -1
                                    if (b.sort && !a.sort) return 1
                                    return a.title < b.title ? -1 : 1
                                })}"
                            on:symbolUpdate="{(e) => {
                                ;(async function () {
                                    await updateTodo(e.detail.id, {
                                        symbol: e.detail.symbol,
                                    })
                                    plan = plan
                                })()
                            }}"
                            on:userUpdate="{(e) => {
                                ;(async function () {
                                    const _p = await updateTodo(e.detail.id, {
                                        user_id: e.detail.user_id,
                                    })
                                    e.detail.user = await getUser(
                                        e.detail.user_id
                                    )
                                    plan = plan
                                })()
                            }}"
                            on:update="{(e) => {
                                onPlanEntryUpdate(e, true)
                            }}"
                            on:delete="{(e) => {
                                deleteTodo(e.detail.id)
                                    .then(() => {
                                        todo = todo.filter(
                                            (t) => t.id != e.detail.id
                                        )
                                    })
                                    .catch((e) => {
                                        console.log(e)
                                        alert('FEHLER: siehe Konsole')
                                    })
                            }}"
                        />
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>

{#if activeUser}
    <Overlay
        closeOnClick="{false}"
        closeOnClickOutside="{false}"
        bind:open="{createOverlayOpen}"
        style="position: fixed; right: 20px; bottom: 20px; left: 260px; padding: 20px; z-index: 100;"
    >
        <button slot="trigger" class="addmore" on:click="{() => {}}">+</button>
        <EntryDialog slot="content"
            on:cancel="{() => {
                createOverlayOpen = false
            }}"
            on:submit="{(e) => {
                onPlanEntryUpdate(e, !e.detail.starts_on)
                createOverlayOpen = false
            }}"
            data="{{
                title: '',
                comment: '',
                hours_per_day: 1,
                user_id: activeUser?.id,
            }}"
        />
    </Overlay>
{/if}

{#if loading || loading2}
    <div
        style="position: fixed; background-color: #00000099; padding: 20px; right: -5px; bottom: -5px; color: white; border-radius: 5px;"
    >
        bitte warten ...
    </div>
{/if}
